<div class="diagram-wrapper">
  <app-sfa-header *ngIf="showHeader" class="margin-top"></app-sfa-header>
  <div class="graph-drawing-area"></div>
</div>
